export default {
    state: {
        clients: [],
        client: [],
        client_id: null,
        family: [],
        comments: [],
        histories: [],
        errors: {},
        url: '/api/hms/clients/list',
        form: {
            f_name: '',
            l_name: '',
            gender: '',
            dob: null,
            ssn: '',
            medicaid: '',
            email: '',
            phone: '',
            ref_date: null,
            facility_id: '',
            notes: '',
        },
        other_form: {},
        family_form: {
            name: '',
            gender: '',
            type: '',
            ssn: '',
            dob: '',
        },
        referral_form: {
            ref_date: null,
            facility_id: '',
            comment: null,
        },
        meta: {
            current_page: 1,
            per_page: 10,
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'name', label: 'Name'},
                {key: 'ssn', label: 'SSN', tdClass: 'text-muted'},
                {key: 'gender', label: 'Gender', sortable: true, tdClass: 'text-muted'},
                {key: 'dob', label: 'DOB', sortable: true},
                {key: 'status', label: 'Status', thClass: 'text-center', tdClass: 'text-center'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        }
    },

    getters: {
        getClients: state => state.facilities,

        getClient: state => state.client,

        getClientFamily: state => state.family,

        getClientComments: state => state.comments,

        getClientHistories: state => state.histories,

        getClientsMeta: state => state.meta,

        getClientTableFields: state => state.table.fields,

        getClientForm: state => state.form,

        getClientErrors: state => state.errors,

        getReferralErrors: state => state.errors,

        getClientOtherForm: state => state.other_form,

        getClientFamilyForm: state => state.family_form,

        getClientReferralForm: state => state.referral_form,
    },

    mutations: {
        setClients: (state, payload) => {
            state.clients = payload;
        },

        setClient: (state, payload) => {
            state.client_id = payload.client_id;
            state.client = payload;
        },

        setClientsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setClientErrors: (state, payload) => {
            state.errors = payload;
        },

        setClientFamily: (state, payload) => {
            state.family = payload;
        },

        setClientComments: (state, payload) => {
            state.comments = payload;
        },

        setClientHistories: (state, payload) => {
            state.histories = payload;
        },

        setClientForm: state => {
            state.form = {
                f_name: '',
                l_name: '',
                gender: '',
                dob: null,
                ssn: '',
                medicaid: '',
                email: '',
                phone: '',
                ref_date: null,
                facility_id: '',
                notes: '',
            };

            state.errors = {};
        },

        resetClientsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setClientOtherForm: state => {
            state.other_form = {
                status: '',
                date: null,
                comment: '',
            };

            state.errors = {};
        },

        setClientFamilyForm: state => {
            state.family_form = {
                name: '',
                gender: '',
                type: '',
                relation: '',
                ssn: '',
                dob: '',
            };

            state.errors = {};
        },

        setClientReferralForm: state => {
            state.referral_form = {
                ref_date: null,
                facility_id: '',
                comment: '',
            };

            state.errors = {};
        },
    },

    actions: {
        fetchClients: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url+'?state', {params: parameters})
                    .then(response => {
                        commit('setClients', response.data);

                        commit('setClientsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setClientErrors', error.response.data.errors);

                        reject();
                    });
            });
        },

        fetchClient: ({state, commit}, client_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + client_id)
                    .then(response => {
                        commit('setClient', response.data);
                        commit('setClientOtherForm', response.data);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitClient: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setClientErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateClient: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.client_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setClientErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteClient: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.client_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },

        fetchEditClient: ({state, commit}, client_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + client_id + '/edit')
                    .then(response => {
                        state.client_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitClientStatus: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.client_id + '/status', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setClientErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        submitClientFamily: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url + '/' + state.client_id + '/family', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setClientErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteClientFamily: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + state.client_id + '/family/' + payload.member_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setClientErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        submitClientComment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url + '/' + state.client_id + '/comments', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setClientErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        fetchClientComments: ({state, commit}, client_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + client_id + '/comments')
                    .then(response => {
                        commit('setClientComments', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchClientFamily: ({state, commit}, client_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + client_id + '/family')
                    .then(response => {
                        commit('setClientFamily', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchClientHistories: ({state, commit}, client_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + client_id + '/histories')
                    .then(response => {
                        commit('setClientHistories', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchEditClientComment: ({state, commit}, comment_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + state.client_id + '/comments/' + comment_id + '/edit')
                    .then(response => {
                        state.other_form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        updateClientComment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.client_id + '/comments/' + payload.id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setClientErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteClientComment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + state.client_id + '/comments/' + payload.comment_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },

        submitClientReferral: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + payload.client_id + '/rereferral', payload.form)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setClientErrors', error.response.data.errors);

                        reject();
                    });
            })
        },
    }
}
